import { combineReducers, compose, createStore as _createStore, applyMiddleware } from 'redux';
import thunk, { ThunkAction } from 'redux-thunk';
import { IApplicationState, TReduxActions, TReduxStore } from '../../types/redux';
import { IConfig } from '@cian/config/shared';
import { ILogger } from '@cian/logger/shared';
import { buildersListReducer } from '../../reducers/builderReducer/reducer';
import { IHttpApi } from '@cian/http-api';
import { callReducer } from '../../reducers/call/reducer';
import { IBuildersList } from '../../types/builders';
import { createSimpleReducer } from './createSimpleReducer';

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */

export interface IState {
  buildersList: IBuildersList;
  abGroup: number;
}
export interface IContext {
  config: IConfig;
  logger: ILogger;
  httpApi: IHttpApi;
}
export type IThunkActionCreator<T = void> = ThunkAction<T, IApplicationState, IContext, TReduxActions>;

export function createReduxStore(initialState: IApplicationState, context: IContext): TReduxStore {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    buildersList: buildersListReducer,
    abGroup: createSimpleReducer(initialState.abGroup),
    call: callReducer,
    geo: createSimpleReducer(initialState.geo),
    buildersProjectsLocations: createSimpleReducer(initialState.buildersProjectsLocations),
    breadcrumbs: createSimpleReducer(initialState.breadcrumbs),
  });

  const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
  const storeEnchancers = composeEnhancers(
    applyMiddleware(thunk.withExtraArgument(context)),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) as any;

  const createStore = (): TReduxStore =>
    _createStore<IApplicationState, TReduxActions, IApplicationState, {}>(reducers, initialState, storeEnchancers);

  return createStore();
}
